import { currentEnv, endpoints } from "../Api/configs";

/**
 * Create a payment session for solo streaming token purchase
 * Calls the event-socket-service API
 */
export const createSoloStreamingPaymentSession = async (
  accessToken: string,
  tokens: number,
  price: string,
  streamId: string,
  streamUsername: string,
  countryCode: string = "GB"
): Promise<{
  statusCode: number;
  body?: {
    sessionId: string;
    url: string;
    message?: string;
  };
  message?: string;
}> => {
  const url = `${currentEnv.eventSocketUrl}/${endpoints.soloStreaming.createPaymentSession}`;

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify({
        tokens,
        price,
        streamId,
        streamUsername,
        countryCode,
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      return {
        statusCode: response.status,
        message: data?.message || "Failed to create payment session",
      };
    }

    return {
      statusCode: data.statusCode || 200,
      body: data.body || data,
    };
  } catch (error) {
    console.error("[SoloStreamingService] Payment session error:", error);
    return {
      statusCode: 500,
      message: "Network error occurred",
    };
  }
};
